
import * as slimeCore from '@qsk/slime-core';
import slime_components_float_icon from '@qsk/slime-components-float-icon';
import slime_components_calendar_subscribe from '@qsk/slime-components-calendar-subscribe';
import slime_components_anchor from '@qsk/slime-components-anchor';
import slime_components_coupon from '@qsk/slime-components-coupon';
import slime_components_gap from '@qsk/slime-components-gap';
import slime_components_banner from '@qsk/slime-components-banner';
import slime_components_subscribe from '@qsk/slime-components-subscribe';
import slime_components_textarea from '@qsk/slime-components-textarea';
import slime_components_seckill_tabs from '@qsk/slime-components-seckill-tabs';
import slime_components_hotspots from '@qsk/slime-components-hotspots';
import slime_components_bottom_nav from '@qsk/slime-components-bottom-nav';
import slime_components_video from '@qsk/slime-components-video';
import slime_components_goods from '@qsk/slime-components-goods';
import slime_components_tabs from '@qsk/slime-components-tabs';
import slime_components_seckill_list from '@qsk/slime-components-seckill-list';
import slime_components_cash_back_activity from '@qsk/slime-components-cash-back-activity';
import slime_components_lottery from '@qsk/slime-components-lottery';
import slime_components_table from '@qsk/slime-components-table';
import slime_components_new_user_coupon from '@qsk/slime-components-new-user-coupon';
import slime_components_tq_repurchase from '@qsk/slime-components-tq-repurchase';
import slime_components_editor from '@qsk/slime-components-editor';
import slime_components_buying from '@qsk/slime-components-buying';
import slime_components_bl_card from '@qsk/slime-components-bl-card';
import slime_components_freebuy from '@qsk/slime-components-freebuy';
import slime_components_user_callback_redpacket from '@qsk/slime-components-user-callback-redpacket';


const componentArray = [
  slime_components_float_icon,
  slime_components_calendar_subscribe,
  slime_components_anchor,
  slime_components_coupon,
  slime_components_gap,
  slime_components_banner,
  slime_components_subscribe,
  slime_components_textarea,
  slime_components_seckill_tabs,
  slime_components_hotspots,
  slime_components_bottom_nav,
  slime_components_video,
  slime_components_goods,
  slime_components_tabs,
  slime_components_seckill_list,
  slime_components_cash_back_activity,
  slime_components_lottery,
  slime_components_table,
  slime_components_new_user_coupon,
  slime_components_tq_repurchase,
  slime_components_editor,
  slime_components_buying,
  slime_components_bl_card,
  slime_components_freebuy,
  slime_components_user_callback_redpacket,

];

function registerCmp(array) {
  array.forEach((register) => {
    if (register instanceof Array) {
      registerCmp(register);
    } else {
      slimeCore.register(register);
    }
  });
}
registerCmp(componentArray);
